import { IDeepCopy, IToString } from '@common/interfaces';
import { Util } from '@common/utils/util';
import { FilterKeywords } from '@src/suite/common/components/filter/filter-keywords';
import moment from 'moment-timezone';

import { DateTime } from './date-time';

export class DateRange implements IDeepCopy<DateRange>, IToString {
    public from: Date = null;
    public to: Date = null;

    private _custom: string = '';

    public get custom(): string {
        return this._custom;
    }
    public set custom(newValue: string) {
        this._custom = newValue;
    }

    constructor() {}

    public toJSON() {
        return {
            custom: this._custom,
            from: this.from,
            to: this.to,
        };
    }

    public static DateNAOption: string = 'N/A';

    public valid(): boolean {
        if (this.custom) {
            const id: string = this.custom.replace('@date_range_', '').replace(/_/g, '').toUpperCase();
            if (FilterKeywords.globalTablesService.CustomFilterDefsDict[id]) {
                return true;
            }
            return false;
        }
        return !!this.from || !!this.to;
    }

    public get(): [Date, Date] {
        if (this.custom && this.custom.length > 0) {
            return <[Date, Date]>FilterKeywords.getValue(this.custom);
        }
        let { from } = this;
        let to = this.to ? this.to : null;

        if (FilterKeywords.globalTablesService.PersonalTimeZone) {
            if (FilterKeywords.globalTablesService.ClientTimeZone) {
                if (FilterKeywords.globalTablesService.PersonalTimeZone.id !== FilterKeywords.globalTablesService.ClientTimeZone.id) {
                    from = DateTime.convertToTargetTZ(from, FilterKeywords.globalTablesService.PersonalTimeZone.id, FilterKeywords.globalTablesService.ClientTimeZone.id);
                    to = DateTime.convertToTargetTZ(to, FilterKeywords.globalTablesService.PersonalTimeZone.id, FilterKeywords.globalTablesService.ClientTimeZone.id);
                }
            }
        }
        return [from, to];
    }

    public format(locale?: string): string {
        locale = locale || 'en-US';
        let res: string = '';
        if (this.from || this.to) {
            if (this.from) {
                res += `${moment(this.from).locale(locale).format('l')} - `;
            } else {
                res += `${DateRange.DateNAOption} -`;
            }
            if (this.to) {
                res += moment(this.to).locale(locale).format('l');
            } else {
                res += DateRange.DateNAOption;
            }
        }

        return res;
    }

    public toLocaleString(): string {
        let res: string = '';
        if (this.from || this.to) {
            if (this.from) {
                res += `${DateTime.formatMomentToLocalDateString(moment(this.from))} - `;
            } else {
                res += `${DateRange.DateNAOption} -`;
            }
            if (this.to) {
                res += DateTime.formatMomentToLocalDateString(moment(this.to));
            } else {
                res += DateRange.DateNAOption;
            }
        }

        return res;
    }

    public equals(target: DateRange): boolean {
        if (!target) {
            return false;
        }
        return true;
    }

    public deepCopy(): DateRange {
        const ret = new DateRange();
        ret.from = Util.deepCopy(this.from);
        ret.to = Util.deepCopy(this.to);
        ret.custom = Util.deepCopy(this.custom);
        return ret;
    }

    public toString(): string {
        return this.format();
    }
}
